/* src/modules/lessons/api.js */

import gql from 'graphql-tag';

const GROUP_FRAGMENT = gql`
  fragment GroupFragment on Group {
    studentMembers {
      student {
        _id
        university {
          _id
          name
        }
        user {
          _id
          first
          last
        }
      }
    }
  }
`;

const LESSON_FRAGMENT = gql`
  fragment LessonFragment on Lesson {
    _id
    creditsUsed
    course {
      _id
      subject
      number
      university {
        _id
        name
      }
    }
    current {
      startTime {
        timestamp
      }
      timeslots {
        _id
      }
    }
    timeline {
      type
      date {
        timestamp
      }
    }
    status
    price
  }
`;

const SINGLE_LESSON_FRAGMENT = gql`
  fragment SingleLessonFragment on Lesson {
    _id
    location {
      _id
      address
    }
    tutorFee
    studentFee
    timeline {
      type
      emitter
      date {
        timestamp
      }
    }
    charges {
      creditsUsed
      refunded
    }
  }
`;

export const TUTOR_LESSON_FRAGMENT = gql`
  fragment TutorLessonFragment on Lesson {
    ...LessonFragment
    group {
      ...GroupFragment
    }
  }
  ${LESSON_FRAGMENT}
  ${GROUP_FRAGMENT}
`;

export const STUDENT_LESSON_FRAGMENT = gql`
  fragment StudentLessonFragment on Lesson {
    ...LessonFragment
    group {
      tutor {
        _id
        user {
          _id
          first
          last
        }
      }
    }
    studentFee
  }
  ${LESSON_FRAGMENT}
`;

const EXTRA_LESSON_FRAGMENT = gql`
  fragment ExtraLessonFragment on Lesson {
    location {
      _id
      name
    }
    course {
      _id
      subject
      number
      university {
        _id
        name
      }
    }
    group {
      tutor {
        _id
        user {
          _id
          first
          last
        }
      }
      ...GroupFragment
    }
  }
  ${GROUP_FRAGMENT}
`;

export const FETCH_LESSONS_QUERY = gql`
  query fetchLessons($lessonSearchInput: LessonSearchInput!, $sort: [SortInput!], $page: PaginationInput) {
    lessonsAdmin(filter: $lessonSearchInput, sort: $sort, page: $page) {
      count
      lessons {
        ...LessonFragment
        ...ExtraLessonFragment
      }
    }
  }
  ${LESSON_FRAGMENT}
  ${EXTRA_LESSON_FRAGMENT}
`;

// TODO: change content
export const FETCH_LESSON_QUERY = gql`
  query fetchLesson($lesson: ID!) {
    lesson(_lesson: $lesson) {
      ...LessonFragment
      ...ExtraLessonFragment
      ...SingleLessonFragment
    }
  }
  ${LESSON_FRAGMENT}
  ${EXTRA_LESSON_FRAGMENT}
  ${SINGLE_LESSON_FRAGMENT}
`;

export const FETCH_USER_LESSON_QUERY = gql`
  query fetchUserLesson($lesson: ID!) {
    lesson(_lesson: $lesson) {
      ...LessonFragment
      ...ExtraLessonFragment
      ...SingleLessonFragment
    }
  }
  ${LESSON_FRAGMENT}
  ${EXTRA_LESSON_FRAGMENT}
  ${SINGLE_LESSON_FRAGMENT}
`;

export const REFUND_LESSON_MUTATION = gql`
  mutation refundLesson($lesson: ID!, $student: ID!, $amount: Int!) {
    refundLesson(_lesson: $lesson, _student: $student, amount: $amount) {
      ...LessonFragment
      ...ExtraLessonFragment
      ...SingleLessonFragment
    }
  }
  ${LESSON_FRAGMENT}
  ${EXTRA_LESSON_FRAGMENT}
  ${SINGLE_LESSON_FRAGMENT}
`;



// WEBPACK FOOTER //
// ./src/modules/lessons/api.js